import React, { useState, useEffect } from 'react';

import { Dropdown, DropdownItem } from '@/components/common/Dropdown';
import { PrivateAicon } from '@/components/common/Aicons';

interface CustomNoteDropdownProps {
  checkStates: CustomNoteCheckState;
  onChangeState: (newStates: CustomNoteCheckState) => void;
}

export interface CustomNoteCheckState {
  isCheckedScore: boolean;
  isCheckedMemo: boolean;
}

const CustomNoteDropdown: React.FC<CustomNoteDropdownProps> = ({ checkStates, onChangeState }) => {
  const [checkboxStates, setCheckboxStates] = useState<CustomNoteCheckState>({
    isCheckedScore: checkStates.isCheckedScore,
    isCheckedMemo: checkStates.isCheckedMemo
  });

  const handleChangeState = (key: keyof CustomNoteCheckState) => (event: React.ChangeEvent<HTMLInputElement>) => {
    // チェックボックスの状態を更新し、親コンポーネントに伝える
    setCheckboxStates((prevState) => ({ ...prevState, [key]: event.target.checked }));
  };

  useEffect(() => {
    onChangeState(checkboxStates);
  }, [checkboxStates]);

  return (
    <>
      <Dropdown
        position="bottom-right"
        trigger={
          <button
            type="button"
            className="h-8 text-base bg-white border border-gray-300 hover:bg-gray-100 focus:ring-2 focus:outline-none focus:ring-blue-500 rounded-lg px-4 py-2 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
            <svg
              className="w-3 h-3 me-1 text-gray-800 dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 18 18">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M11 14h6m-3 3v-6M1.857 1h4.286c.473 0 .857.384.857.857v4.286A.857.857 0 0 1 6.143 7H1.857A.857.857 0 0 1 1 6.143V1.857C1 1.384 1.384 1 1.857 1Zm10 0h4.286c.473 0 .857.384.857.857v4.286a.857.857 0 0 1-.857.857h-4.286A.857.857 0 0 1 11 6.143V1.857c0-.473.384-.857.857-.857Zm-10 10h4.286c.473 0 .857.384.857.857v4.286a.857.857 0 0 1-.857.857H1.857A.857.857 0 0 1 1 16.143v-4.286c0-.473.384-.857.857-.857Z"
              />
            </svg>
            {/* カスタマイズ */}
            <svg
              className="w-2 h-2 ms-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 4 4 4-4"
              />
            </svg>
          </button>
        }>
        <div className="px-2 py-2 w-fix border border-gray-300 rounded-lg text-gray-700">
          {/* <div className="my-1 w-full text-xs text-center text-gray-400">サッカーノートの編集</div> */}
          <DropdownItem closeOnClick={false}>
            <div className="flex p-2 rounded hover:bg-gray-100 dark:hover:bg-gray-600">
              <label className="relative inline-flex items-center w-full cursor-pointer">
                <input
                  id="checkScore"
                  type="checkbox"
                  className="sr-only peer"
                  checked={checkboxStates.isCheckedScore}
                  onChange={handleChangeState('isCheckedScore')}
                />
                <div className='w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-0 peer-focus:ring-green-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-600 peer-checked:after:translate-x-full rtl:peer-checked:after:translate-x-[-100%] peer-checked:after:border-white after:content-[""] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-500 peer-checked:bg-green-500'></div>
                <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Score（ゲームスコア）</span>
              </label>
            </div>
          </DropdownItem>
          <DropdownItem closeOnClick={false}>
            <div className="flex p-2 rounded hover:bg-gray-100 dark:hover:bg-gray-600">
              <label className="relative inline-flex items-center w-full cursor-pointer">
                <input
                  id="checkMemo"
                  type="checkbox"
                  className="sr-only peer"
                  checked={checkboxStates.isCheckedMemo}
                  onChange={handleChangeState('isCheckedMemo')}
                />
                <div className='w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-0 peer-focus:ring-green-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-600 peer-checked:after:translate-x-full rtl:peer-checked:after:translate-x-[-100%] peer-checked:after:border-white after:content-[""] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-500 peer-checked:bg-green-500'></div>
                <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Memo（自由記入）</span>
                <div>
                  <PrivateAicon />
                </div>
              </label>
            </div>
          </DropdownItem>
        </div>
      </Dropdown>
    </>
  );
};

export default CustomNoteDropdown;
